import { render } from "./AboutUs.vue?vue&type=template&id=6d57dd8a&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=6d57dd8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d57dd8a"]])

export default __exports__